<template>
  <div class="app">
    <a
      href="#main-content"
      class="skip-link"
      @click.prevent="skipToMainContent"
    >
      {{ $t('common.skipToMain') }}
    </a>
    <Header />
    <main id="main-content" tabindex="-1">
      <router-view />
    </main>
    <Footer />
    <AppToast />
  </div>
</template>

<script setup>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import AppToast from './components/common/AppToast.vue'

// 无障碍跳转：手动控制滚动到主要内容，适配所有路由场景
const skipToMainContent = () => {
  const mainContent = document.getElementById('main-content')
  if (mainContent) {
    // 平滑滚动到主要内容区域
    mainContent.scrollIntoView({ behavior: 'smooth' })
    // 无障碍优化：聚焦到主要内容，方便屏幕阅读器识别
    mainContent.focus({ preventScroll: true })
  }
}
</script>

<style scoped>
.app {
  min-height: 100vh;
}
</style>
